const env = import.meta.env as Record<string, string | undefined>;

/* ============================================
 * OLD MICROSERVICES CONFIG (Preserved for reference)
 * Remove this comment block once monolith is stable
 * ============================================

const trimTrailingSlash = (value: string) => value.replace(/\/+$|$/, '');
const ensureLeadingSlash = (value: string) =>
  value.startsWith('/') ? value : `/${value}`;

const DEFAULT_BASE_URL = trimTrailingSlash(env.VITE_BASE_API_URL ?? '');

const buildServiceUrl = (envKey: string, fallbackPath: string) => {
  const override = env[envKey];
  if (override) {
    return trimTrailingSlash(override);
  }

  const normalizedPath = ensureLeadingSlash(fallbackPath);
  return DEFAULT_BASE_URL
    ? `${DEFAULT_BASE_URL}${normalizedPath}`
    : normalizedPath;
};

export const config = {
  BASE_USER_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_USER_SERVICE_BASE_URL',
    '/user/api'
  ),
  BASE_POST_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_POST_SERVICE_BASE_URL',
    '/post/api'
  ),
  BASE_COMMENT_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_COMMENT_SERVICE_BASE_URL',
    '/comment/api'
  ),
  BASE_GAMIFICATION_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_GAMIFICATION_SERVICE_BASE_URL',
    '/gamification/api'
  ),
  BASE_FRIEND_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_FRIEND_SERVICE_BASE_URL',
    '/friend/api'
  ),
  BASE_NOTIFICATION_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_NOTIFICATION_SERVICE_BASE_URL',
    '/notification/api'
  ),
  BASE_COMPANY_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_COMPANY_SERVICE_BASE_URL',
    '/company/api'
  ),
  BASE_CHAT_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_CHAT_SERVICE_BASE_URL',
    '/chat/api/chats'
  ),
  BASE_GROUP_CHAT_MICROSERVICE_API_URL: buildServiceUrl(
    'VITE_GROUP_CHAT_SERVICE_BASE_URL',
    '/chat/api/group-chat'
  ),
  BASE_SEARCH_API_URL: buildServiceUrl(
    'VITE_SEARCH_SERVICE_BASE_URL',
    '/search/api'
  ),
};

 * ============================================ */

/**
 * NEW MONOLITH CONFIG
 *
 * API base URL - defaults to '/api' for local dev (proxied to port 3001).
 * Override with VITE_API_URL for production (e.g., https://api.yoursite.com/api).
 */
const API_BASE_URL = env.VITE_BASE_API_URL || '/api';

export const config = {
  // Monolith API - single base URL for all services
  API_BASE_URL,
  // Other configurations (non-API)
  STRIPE_PUBLIC_KEY: env.VITE_STRIPE_PUBLISHABLE_KEY,
  // Refetch token once every 55 sec
  TWILIO_TOKEN_POLLING_INTERVAL: 55 * 1000,
};
